import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './e4a50b6753f713af0aa80c577fe5a8027ea632b55ab1287fc646905f283ff047.cfe-internal.js';
import Switch from './b250c11336a7e582ef4b3e990f7b955f0b1e8d4281209f727f2910be4504f691.cfe-internal.js';
import Label from '../Label/6d4e74e6cc7c9acab3f6aa6fb3706afd5f03a05ffbc4895b899f60f06ab25143.cfe-internal.js';

var _excluded = ["id", "label", "className", "checked", "defaultChecked", "disabled", "onChange", "value", "inputProps", "aria-describedby"];
var SwitchField = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      label = _ref.label,
      className = _ref.className,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      value = _ref.value,
      inputProps = _ref.inputProps,
      ariaDescribedBy = _ref['aria-describedby'],
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement(Label, _extends({}, rest, {
    ref: ref,
    htmlFor: id,
    className: classNames(className, styles.label, _defineProperty({}, styles.labelDisabled, disabled))
  }), /*#__PURE__*/React__default.createElement(Switch, {
    inputProps: inputProps,
    className: styles.wrappedInput,
    id: id,
    checked: checked,
    defaultChecked: defaultChecked,
    onChange: onChange,
    disabled: disabled,
    value: value,
    "aria-describedby": ariaDescribedBy
  }), label);
});
var SwitchField$1 = SwitchField;

export { SwitchField$1 as default };
